// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { NetworkPolling } from './NetworkPolling';
import { OperationLimits } from './OperationLimits';
import { WebsocketClearCache } from './WebsocketClearCache';
import { WebsocketToggle } from './WebsocketToggle';
import { VersionsPreview } from './versions/VersionsPreview';

export const AllSettings: React.FC = () => {
  return (
    <>
      <NetworkPolling />
      <OperationLimits />
      <WebsocketToggle />
      <WebsocketClearCache />
      <VersionsPreview />
    </>
  );
};
